import * as z from "zod";

export const whatsappConnectionSchema = z.object({
  id: z.number(),
  whatsappId: z.string(),
  phoneNumber: z.string(),
});
